import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SEO from "@/components/SEO";
import StaticBackdrop from "@/components/StaticBackdrop";
import SiteNav from "@/components/SiteNav";
import { PrimaryCTA } from "@/components/shared/CTA";
import { Overline } from "@/components/shared/Primitives";
import { container, lineReveal, reveal } from "@/components/shared/motion";
import { url } from "@/data/site";

export default function NotFound() {
  return (
    <div className="relative min-h-screen" data-testid="not-found-page">
      <SEO
        title="This experience does not exist — Elentara"
        description="The page you were looking for is not part of the Elentara experience. Return to the studio."
        canonical={url("/404")}
      />
      <StaticBackdrop />
      <SiteNav />
      <main className="relative z-10 flex min-h-screen flex-col justify-center px-6 md:px-16 lg:px-24">
        <motion.div variants={container} initial="hidden" animate="show" className="max-w-4xl">
          <motion.div variants={reveal}>
            <Overline className="mb-8">Error 404</Overline>
          </motion.div>
          <h1 className="font-display font-black uppercase leading-[0.98] tracking-tight">
            <span className="block overflow-hidden">
              <motion.span
                variants={lineReveal}
                data-testid="not-found-title"
                className="block bg-gradient-to-r from-[#F4F6FB] via-[#c9b8f5] to-[#7dd8ea] bg-clip-text text-4xl text-transparent md:text-6xl lg:text-7xl"
              >
                This experience does not exist.
              </motion.span>
            </span>
          </h1>
          <motion.p
            variants={reveal}
            className="mt-8 max-w-xl text-sm leading-relaxed text-[#F4F6FB]/55 md:text-base"
          >
            The route you followed leads nowhere — it may have moved, or it may never have been
            built. Everything that does exist is one step away.
          </motion.p>
          <motion.div variants={reveal} className="mt-12 flex flex-wrap items-center gap-5">
            <PrimaryCTA to="/" testId="not-found-home-link">
              Return to Elentara
            </PrimaryCTA>
            <Link
              to="/work"
              data-testid="not-found-work-link"
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#F4F6FB]/50 transition-colors duration-300 hover:text-[#06B6D4]"
            >
              View all work →
            </Link>
          </motion.div>
        </motion.div>
      </main>
    </div>
  );
}
